import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

let authRedirectInFlight = false;

export const authSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      const status = error?.status;
      const isLoginRequest = req.url.includes('/api/auth/login') || req.url.includes('/api/v1/auth/signin');

      if (status === 401 && !isLoginRequest && !authRedirectInFlight) {
        const hadAuthHeader = req.headers.has('Authorization');
        if (hadAuthHeader) {
          authRedirectInFlight = true;
          authService.logout();
          router.navigate(['/login']).finally(() => {
            authRedirectInFlight = false;
          });
        }
      } else if (status === 403 && !isLoginRequest) {
        const isMutation = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method);
        if (!isMutation) {
          router.navigate(['/forbidden']);
        }
      }

      return throwError(() => error);
    })
  );
};
